var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"component":_vm.$options.name}},[(_vm.hasBanner && _vm.banners.length)?_c('v-sheet',{staticClass:"pa-5"},[_c('common-promotion-carousel',{attrs:{"adverts":_vm.banners,"orientation":"landscape"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }